import React from 'react';
import { CONTACT_PARTS, normalizeContactValue } from './contactValue';

// Grouped contact inputs. The answer is a single { name, phone, email, address }
// object stored under the field id; only the name is required.
const INPUT_CLASS =
  'w-full bg-gray-700 border border-gray-600 rounded px-3 py-2 text-white placeholder-gray-400 focus:border-purple-500 focus:outline-none disabled:opacity-70 disabled:cursor-not-allowed';

const ContactField = ({ field, value, onChange, disabled = false }) => {
  const contact = normalizeContactValue(value);

  const handlePartChange = (key, partValue) => {
    onChange(field.id, { ...contact, [key]: partValue });
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 bg-gray-700/30 border border-gray-600 rounded-lg p-3">
      {CONTACT_PARTS.map((part) => {
        const inputId = `contact-${field.id}-${part.key}`;
        const sharedProps = {
          id: inputId,
          value: contact[part.key],
          onChange: (e) => handlePartChange(part.key, e.target.value),
          required: part.required,
          disabled,
          autoComplete: part.autoComplete,
          placeholder: part.placeholder,
          className: INPUT_CLASS,
        };
        return (
          <div key={part.key} className={`space-y-1 ${part.fullWidth ? 'sm:col-span-2' : ''}`}>
            <label htmlFor={inputId} className="block text-sm text-gray-300">
              {part.label}
              {part.required && <span className="text-red-400 ml-1">*</span>}
            </label>
            {part.inputType === 'textarea' ? (
              <textarea {...sharedProps} rows={2} className={`${INPUT_CLASS} resize-none`} />
            ) : (
              <input {...sharedProps} type={part.inputType} />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ContactField;
